export default "__VITE_ASSET__jObEUo15__"